import { ref } from 'vue'

const propertyTypeList = ref( [] )

export default propertyTypeList